// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3uCDS","gfeWrapper":"CalendarEvent_gfeWrapper__mpHoi"};